import { render } from "./CustomHook.vue?vue&type=template&id=7a8b1050"
import script from "./CustomHook.vue?vue&type=script&lang=ts"
export * from "./CustomHook.vue?vue&type=script&lang=ts"
script.render = render

export default script